import { graphql } from "../gql";

export const createBatchClaimCommentMutationDoc = graphql(`
  mutation createBatchClaimComment($claimId: UUID!, $body: String!) {
    createBatchClaimComment(batchClaimId: $claimId, body: $body) {
      id
      body
      authorId
      authorName
      createdAt
    }
  }
`);
